export default __webpack_public_path__ + "static/media/lc-3.7aaee291.JPG";